export abstract class ValidatorConstants {
  static readonly PasswordRequirements: string = "Password Policy:\n At least 8 characters\n1 Uppercase\n 1 Lowercase\n 1 Number\n Inclusion of at least one special character, eg. ! @ # $ % ^ & * ? _ ~ - ( )\n No common words\n No username\n No spaces";
}
